import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import Title from "../../../components/title/Title";
import AncestorBranch from "../components/tree/AncestorBranch";
import BranchItem from "../components/tree/BranchItem";

const TabAncestors = ({individual, ancestors}: any) => {

    return (
        <React.Fragment>
            <Container fluid="lg" className="inline">
                <Row>
                    <Col sm={12} md={12} xl={12}>
                        <Title title={"Vorfahren von " + individual.firstName + " " + individual.lastName}/>
                    </Col>
                </Row>
            </Container>
            {ancestors.parents
                ?
                <Container fluid className="scrollWindow">
                    <div>
                        <div id="wrapper">
                            <BranchItem individual={individual}/>
                            <AncestorBranch entries={[ancestors.parents.partner1, ancestors.parents.partner2]} level={1}/>
                        </div>
                    </div>
                </Container>
                :
                <Container fluid="lg" className="inline">
                    Für diese Person sind noch keine Vorfahren erfasst
                </Container>
            }
        </React.Fragment>
    )
};


export default TabAncestors;
